import React, { Component } from "react";
import { NavItem, Nav } from "react-bootstrap";
import { connect } from 'react-redux';
import logoutIcon from "assets/img/logout.svg";

class HeaderLinksPage extends Component {
  render() {
    const { adminType, loggedIn } = this.props;
    return (
      <div>
        <Nav pullRight>
          {
              loggedIn && (adminType === 'admin' || adminType === 'company') &&
              <NavItem href="/Admin-login">Logout <img src={logoutIcon} alt="logoutIcon" height="18" style={{"marginLeft":"5px"}} /> </NavItem>
              
          }
        </Nav>
      </div>
    );
  }
}


function mapStateToProps(state) {
  const { userAdmin, adminType, loggedIn } = state.adminReducer;
    return {
      userAdmin, adminType, loggedIn
    };
}


const HeaderLinks = connect(mapStateToProps)(HeaderLinksPage);
export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Admin/Header/HeaderLinks.jsx